
export default {
  name: 'BlogAuthorLogoName',
  props: {
    data: {
      type: Object,
      default: () => ({
        Title: undefined,
        LifeStageOffering: [],
      }),
    },
    image: {
      type: Object,
      default: () => ({}),
    },
    name: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      activeItem: "lifestageoffering-1",
      strapiData: []
    }
  },
  computed: {
  },
  methods: {
  },
}
